"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This class represents a numeric range between
 * a starting and ending value, inclusive.
 */
var Range = function () {
  /**
   * Creates a new Range
   * @param {number} start the starting index of the range
   * @param {number} end the ending index of the range, inclusive
   */
  function Range(start, end) {
    (0, _classCallCheck3.default)(this, Range);

    /**
     * The starting index of the range
     * @type {number}
     */
    this.start = start;

    /**
     * The ending index of the range, inclusive
     * @type {number}
     */
    this.end = end;
  }

  /**
   * The length of the range
   * @type {number}
   */


  /**
   * Returns whether this range is equal to the given range
   * @param {Range} other the range to compare
   * @return {boolean}
   */
  Range.prototype.equals = function equals(other) {
    return other.start === this.start && other.end === this.end;
  };

  /**
   * Returns a copy of the range
   * @return {Range}
   */


  Range.prototype.copy = function copy() {
    return new Range(this.start, this.end);
  };

  /**
   * Returns whether the given value is in the range
   * @param {number} index the index to check
   * @return {boolean}
   */


  Range.prototype.contains = function contains(index) {
    return index >= this.start && index <= this.end;
  };

  /**
   * Extends the range to include the given index
   * @param {number} index the index to ad
   */


  Range.prototype.extend = function extend(index) {
    this.start = Math.min(this.start, index);
    this.end = Math.max(this.end, index);
  };

  /**
   * Merge intersecting ranges
   * @param {number} ranges array of valid Range objects
   * @return {array}
   */


  Range.merge = function merge(ranges) {
    ranges.sort(function (a, b) {
      return a.start - b.start;
    });

    var merged = [ranges[0]];

    for (var i = 1; i < ranges.length; i++) {
      var last = merged[merged.length - 1];
      var next = ranges[i];

      if (next.start <= last.end && next.end <= last.end) {
        // Ignore this range completely.
        // Next is contained inside last
        continue;
      } else if (next.start <= last.end) {
        last.end = next.end;
      } else {
        merged.push(next);
      }
    }

    return merged;
  };

  (0, _createClass3.default)(Range, [{
    key: "length",
    get: function get() {
      return this.end - this.start + 1;
    }
  }]);
  return Range;
}();

exports.default = Range;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/models/Range.js
// module id = 491
// module chunks = 0